// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","683":"component---src-pages-minista-index-tsx"}[chunkId] + "-" + {"245":"baf65e5dcf781c22ae01","453":"3423113a0702313eec03","683":"543b80f1a0cae409785f"}[chunkId] + ".js";
};